<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed, inject } from 'vue'

const __t = inject('__t')
const page = usePage()
const isRtl = computed(() => page.props.locale === 'ar')
</script>

<template>
    <section class="relative w-full overflow-hidden bg-  hero-section" :dir="isRtl ? 'rtl' : 'ltr'">

        <!-- Full-width factory background image -->
        <div class="absolute inset-0 z-0">
            <img src="/assets/almatin/1-(2).png" :alt="__t('hero_image_alt')"
                class="w-full h-full object-cover object-center" />
            <!-- Blue overlay covering the full image to give the blue tint -->
            <!-- <div class="absolute inset-0 bg-primary/80"></div> -->
            <!-- Fade on the right side so the right text area appears more solid blue -->
            <!-- <div class="absolute inset-0 bg-gradient-to-l from-primary via-primary/85 to-transparent"></div> -->
        </div>

        <!-- Content wrapper -->
        <div class="relative z-10 container mx-auto px-6 lg:px-12 flex items-center h-ful l py-20 md:py-40 lg:py-46">
            <div class="flex w-full flex-col lg:flex-row items-center justify-between gap-10">

                <!-- Left side: factory image visual placeholder (transparent – image is behind) -->
                <div class="hidden rtl:lg:block lg:w-1/3"></div>

                <!-- Right side: Text content -->
                <div class="w-full lg:w-2/3 flex flex-col rtl:items-end ltr:items-start space-y-6" data-aos="fade-left"
                    data-aos-duration="1000">
                    <div class="space-y-3" data-aos="fade-down" data-aos-delay="200">
                        <h1
                            class="font-black text-primary leading-tight drop-shadow-xl text-6xl md:text-6xl lg:text-8xl mt-10 mt-md-0">
                            {{ __t('hero_title') }}
                        </h1>
                        <h2 class="font-black text-primary leading-tight drop-shadow-xl text-3xl md:text-4xl lg:text-5xl ">
                            {{ __t('hero_subtitle') }}
                        </h2>
                    </div>

                    <!-- Yellow experience badge -->
                    <div data-aos="fade-up" data-aos-delay="500" class="relative mb-10">
                        <div class="bg-secondary px-8 py-3 inline-block shadow-lg experience-badge">
                            <p class="font-black text-primary text-xl md:text-2xl lg:text-3xl whitespace-nowrap">
                                {{ __t('hero_badge_text') }}
                            </p>
                        </div>
                        <!-- Double border decoration -->
                        <div class="absolute -bottom-[5px] w-full h-full border-2 border-secondary pointer-events-none"
                            :class="isRtl ? '-right-[5px]' : '-left-[5px]'">
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
</template>

<style scoped>
.hero-section {
    min-height: 480px;
    height: 100vh;
    max-height: 800px;
}

@media (max-width: 768px) {
    .hero-section {
        height: auto;
        min-height: 600px;
        max-height: none;
    }
}

.experience-badge {
    position: relative;
    z-index: 1;
}
</style>
